export enum OutlookIntegrationStatus {
  Inactive = 'Inactive',
  Active = 'Active',
  Expired = 'Expired',
}

export interface OutlookIntegrationState {
  status: OutlookIntegrationStatus;
}

export enum OutlookConnectionResult {
  Pending = 'Pending',
  Connected = 'Connected',
  Cancelled = 'Cancelled',
  PersonalAccountRejected = 'PersonalAccountRejected',
  CalendarError = 'CalendarError',
  Error = 'Error',
}

export interface OutlookConnectionStatus {
  result: OutlookConnectionResult;
}

export interface OutlookEligibleActionPlans {
  count: number;
}

export interface OutlookDeactivationResult {
  calendarRemoved: boolean;
}
